export default {
  // unpublish the existing stream before publishing the new video/screen share stream
  async unpublish() {
    await this.rtc.unpublish();

    // close the existing stream if it's a screen stream
    // retain the video stream to prevent the further permission notif on firefox
    if (this.localScreenTrack && !this.constraints.screen) {
      this.localScreenTrack.close();
      this.localScreenTrack = null;
    }

    if (this.localScreenAudioTrack && !this.constraints.screen) {
      this.localScreenAudioTrack.close();
      this.localTracks = this.localTracks.filter(
        track => track !== this.localScreenAudioTrack
      );
      this.localScreenAudioTrack = null;
    }
  }
}
